import { swSettings } from "app/common/services/swSettings";
import { AllTrafficChannelsOverviewBarChartContainer } from "app/pages/website-analysis/traffic-sources/mmx/components/ChannelsOverviewBarChart/AllTrafficChannelsOverviewBarChartContainer";
import { getHooksVersion } from "app/UtilitiesAndConstants/UtilityFunctions/hooksUtils";
import { isNoTouchOrTrialOrAfterTrial } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const WWOAllTrafficChannelsOverviewBarChartContainerDS = () => {
    const getCtaLink = (params) => {
        return {
            href: proNavigator.href("digitalsuite_website_marketingchannels", params),
            target: "_self",
        };
    };
    return (
        <AllTrafficChannelsOverviewBarChartContainer
            getCtaLink={getCtaLink}
            isWWO={true}
            unlockHook={{
                component: "WsWebTrafficChannels",
                hookModal: isNoTouchOrTrialOrAfterTrial(swSettings) ? "marketingChannels" : "WebTrafficChannelsFeature",
                version: getHooksVersion(swSettings),
            }}
        />
    );
};
